import styled from 'styled-components';

export const DataContainer = styled.header`
	display: flex;
	flex-direction: column;
	gap: 24px;
`;

export const SectionContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`;
